import { type UseModalState } from "@clipboard-health/ui-components";
import { Dialog } from "@mui/material";
import { type AgentPreferences } from "@src/appV2/Agents/api/useWorkerPreferences/types";
import { z } from "zod";

import { DistanceDialogForm } from "./DistanceDialogForm";

interface ShiftBlockDistanceFilterDialogProps {
  modalState: UseModalState;
  onSubmit: (values: AgentPreferences) => void;
  defaultValues: AgentPreferences;
}

export const shiftBlockDistanceFilterSchema = z.object({
  distance: z.number(),
});

export function ShiftBlockDistanceFilterDialog(props: ShiftBlockDistanceFilterDialogProps) {
  const { modalState, onSubmit, defaultValues } = props;
  const { modalIsOpen, closeModal } = modalState;

  return (
    <Dialog
      fullWidth
      open={modalIsOpen}
      onClose={() => {
        closeModal();
      }}
    >
      <DistanceDialogForm
        defaultValues={defaultValues}
        closeModal={closeModal}
        onSubmit={onSubmit}
      />
    </Dialog>
  );
}
